var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      borderRadius: 10
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_37_470)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 0H2.5C1.83718 0.000721895 1.20171 0.264346 0.73303 0.73303C0.264346 1.20171 0.000721895 1.83718 0 2.5L0 17.5C0.000721895 18.1628 0.264346 18.7983 0.73303 19.267C1.20171 19.7357 1.83718 19.9993 2.5 20H17.5C18.1628 19.9993 18.7983 19.7357 19.267 19.267C19.7357 18.7983 19.9993 18.1628 20 17.5V2.5C19.9993 1.83718 19.7357 1.20171 19.267 0.73303C18.7983 0.264346 18.1628 0.000721895 17.5 0V0Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.875 10H12.75V7.5C12.75 6.81 13.31 6.875 14 6.875H15.25V3.75H12.75C12.2575 3.74994 11.7699 3.84689 11.3149 4.03533C10.8599 4.22376 10.4464 4.49999 10.0982 4.84822C9.74999 5.19645 9.47377 5.60987 9.28533 6.06487C9.0969 6.51986 8.99994 7.00753 9 7.5V10H6.5V13.125H9V20H12.75V13.125H14.625L15.875 10Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_37_470"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.250f9ee922b8fd0af07bdc441fcb80ec.svg";
export { ForwardRef as ReactComponent };